import React from 'react';
import { Card, CardContent } from './ui/card';
import { Music, Building2, Trophy, Tent } from 'lucide-react';

export const UseCasesSection = () => {
  const useCases = [
  {
    icon: Music,
    title: 'Festivaler',
    description: 'Skalerbar drift til mange salgssteder og høje peak-perioder.',
  },
  {
    icon: Building2,
    title: 'Spillesteder',
    description: 'Stabil drift og bedre overblik på tværs af arrangementer.',
  },
  {
    icon: Trophy,
    title: 'Sportsbarer',
    description: 'Hurtig ekspedition og bedre flow i travle perioder.',
  },
  {
    icon: Tent,
    title: 'Pop-up events',
    description: 'Fleksibel opsætning til midlertidige events og kort varsel.',
  },
];

  return (
    <section data-testid="use-cases-section" className="py-24 md:py-32 bg-section-bg">
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground">
            Bygget til live events
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <Card
                key={index}
                data-testid={`usecase-card-${index}`}
                className="group border-transparent hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(11,31,59,0.12)]"
              >
                <CardContent className="p-7">
                  <div className="w-12 h-12 rounded-xl bg-accent-purple/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-accent-purple" />
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                    {useCase.title}
                  </h3>
                  <p className="text-sm text-body-text leading-relaxed">
                    {useCase.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
